import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

export class Option {
  value: any;
  label: string;
}


@Component({
    selector: 'app-form-group-select-validation',
    templateUrl: './form-group-select-validation.component.html',
    styleUrls: ['./form-group-select-validation.component.scss'],
    standalone: false
})
export class FormGroupSelectValidationComponent implements OnInit {
  @Input()
  label: string;

  @Input()
  additionalClass: string;

  @Input()
  model: string;

  @Input()
  options: Option[];

  @Input()
  disabled = false;

  @Input()
  required = false;

  @Input()
  name: string;

  @Input()
  id: string;

  @Input()
  error: string;

  @Input()
  formControlNameValue: string;

  @Input()
  formGroup: FormGroup;

  @Output()
  modelChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  change() {
    this.modelChange.emit(this.model);
  }
}
